import React, { useState } from "react";
import clsx from "clsx";
import { useHistory } from "react-router";
import _ from "lodash";
import NotificationManager from "../../../utils/NotificationMessage";
import PaymentTermTable from "./components/PaymentTermTable";
import PaymentHistoryTable from "./components/PaymentHistoryTable";
import { useSelector } from "react-redux";
import * as paymentSelectors from "../../../selectors/payment";
import GeneralPaymentDisclaimerRemark from "../GeneralPaymentDisclaimerRemark";
import {Container} from "react-bootstrap";
function PaymentDetail({ notificationAlertRef, label, items, loading, paymentConfig }) {
  let history = useHistory();
  const data = useSelector((state) => paymentSelectors.getPaymentItems(state));
  const total = useSelector((state) => paymentSelectors.getPaymentTotal(state));
  const totalAmount = useSelector((state) => paymentSelectors.getPaymentTotalAmount(state));
  const currency = useSelector((state) => paymentSelectors.getPaymentCurrency(state));
  const attributes = paymentSelectors.getPaymentConfigAttributes(paymentConfig);
  const isOperate = _.get(attributes, ["is_operate"], []);
  const startTime = _.get(attributes, ["start_time"], []);
  const cutOffTime = _.get(attributes, ["cutoff_time"], []);

  const handleGoBack = (e) => {
    e.preventDefault();
    history.goBack();
  };

  const handleContinue = (value) => {
    if (!isOperate) {
      NotificationManager.error(`Operation Hours ${startTime} - ${cutOffTime}. Please try again by tomorrow.`);
    } else if (value === null) {
      NotificationManager.error("Please select one payment method");
    } else {
      history.push(`/dashboard/payment/${value}-transfer`);
    }
  };

  return (
      <Container fluid>
        <div className={"primary-border-table-border"} style={{ backgroundColor: "white" }}>
          <div className={clsx("custom-card-label-container text-center")}>
            <h2>Payment Detail</h2>
          </div>
          <br />
          <div className="padding-12px d-flex">
            <p className="payment-detail-title text-center w-100">
              Please review the following transaction details and select the payment method
            </p>
            {/*<span className="e-payment-history-link">History</span>*/}
          </div>
          <PaymentHistoryTable
            selectedCurrency={currency}
            paymentConfig={paymentConfig}
            total={total}
            totalAmount={totalAmount}
            data={data}
            handleContinue={handleContinue}
            handleGoBack={handleGoBack}
          />
        </div>
        <GeneralPaymentDisclaimerRemark></GeneralPaymentDisclaimerRemark>
      </Container>
  );
}

export default PaymentDetail;
